import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { SpinnerComponent } from 'src/app/shared/spinner/spinner.component';
import { ConsultaGarantiaModel, ResponseConsultaGarantiaModel, SelectModel, AlertModel } from '../../../models/consulta-garantia';
import { ConsultaGarantiaService } from '../../../services/consulta-garantia.service';

@Component({
    selector: 'app-consulta-garantia',
    templateUrl: './consulta-garantia.component.html',
    styleUrls: ['./consulta-garantia.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsultaGarantiaComponent implements OnInit {
  consultaGarantia: ConsultaGarantiaModel = {
    nombre: '',
    tipoIdentificacion: '',
    numeroIdentificacion: '',
    telefonoContacto: '',
    motivoConsulta: '',
    codigoGarantia: ''
  }

  response: ResponseConsultaGarantiaModel = {
    "ordenante": {
      "nombre": "",
      "tipoIdentificacion": "",
      "numeroIdentificacion": "",
      "digitoVerificacion": ""
    },
    "beneficiario": {
      "nombre": "",
      "tipoIdentificacion": "",
      "numeroIdentificacion": "",
      "digitoVerificacion": ""
    },
    "garantia": {
      "referencia": "",
      "fechaEmision": "",
      "fechaVencimiento": "",
      "moneda": "",
      "valorOperacion": "",
      "propositoGarantia": ""
    }
  }

  select: SelectModel[] = [{ type: 'CC', name: 'Cédula de Ciudadanía' }, { type: 'NT', name: "Número de Identificación Tributaria" }]

  loading: boolean = false;
  showResult: boolean = false;
  showError: boolean = false;
  alerts: AlertModel[] = [{
    type: "danger", message: {
      messageTitle: "",
      items: [""],
      messageFoot: ""
    }
  }];

  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private garantiaService: ConsultaGarantiaService,
    private spinner: SpinnerComponent) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        vNombre: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(75), Validators.pattern("^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$")]),
        vTipoIdentificacion: new FormControl('', [Validators.required]),
        vNumeroIdentificacion: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(11), Validators.pattern("[0-9]*")]),
        vTelefonoContacto: new FormControl('', [Validators.required, Validators.pattern("[0-9]*")]),
        vMotivoConsulta: new FormControl('', [Validators.required, Validators.pattern("^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$")]),
        vCodigoGarantia: new FormControl('', [Validators.required, Validators.pattern("[a-zA-Z0-9]*")])
      }
    );

  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  toUpperCaseGarantia(): void {
    this.consultaGarantia.codigoGarantia = this.consultaGarantia.codigoGarantia.toUpperCase();
  }

  consultaGarantiaFun(formValid: boolean): void {
    if (formValid) {
      this.loading = !this.loading;
      this.showResult = false;
      this.showError = false;

      this.spinner.setShow();

      this.garantiaService.findConsultaGarantiaModel(this.consultaGarantia)
        .subscribe((responde) => {

         

          if (responde != null) {

            if (responde.status == 200) {

              if (responde.body.codigo_garantia !== "" && typeof responde.body.codigo_garantia !== "undefined") {

                this.response.ordenante.nombre = responde.body.nombre_ordenante;
                this.response.ordenante.tipoIdentificacion = responde.body.tipo_id_ordenante;
                this.response.ordenante.numeroIdentificacion = responde.body.num_id_ordenante;
                this.response.ordenante.digitoVerificacion = responde.body.digito_verificacion_ord;

                this.response.beneficiario.nombre = responde.body.nombre_beneficiario;
                this.response.beneficiario.tipoIdentificacion = responde.body.tipo_id_beneficiario;
                this.response.beneficiario.numeroIdentificacion = responde.body.num_id_beneficiario;
                this.response.beneficiario.digitoVerificacion = responde.body.digito_verificacion_bene;

                this.response.garantia.referencia = responde.body.codigo_garantia;
                this.response.garantia.fechaVencimiento = responde.body.fecha_vencimiento;
                this.response.garantia.moneda = responde.body.moneda;
                this.response.garantia.valorOperacion = responde.body.valor_operacion;
                this.response.garantia.propositoGarantia = responde.body.proposito_garantia;
                this.response.garantia.fechaEmision = responde.body.fecha_emision;

                this.showResult = true;

              } else {

                this.alerts = [{
                  type: "info", message: {
                    messageTitle: "Referencia de garantía no encontrada, por favor valide la referencia o comuníquese a las líneas para realizar la consulta.",
                    items: ["Bogotá: (601) 7462060 ext. 21423", "Cali: (602) 4850707 ext. 21423", "Medellín: (604) 6044835 ext. 21423", "Barranquilla: (605) 3861198 ext. 21423"],
                    messageFoot: ""
                  }
                }];

                this.showError = true;

              }
            } else if (responde.status == 204){
              
              this.alerts = [{
                type: "info", message: {
                  messageTitle: "Referencia de garantía no encontrada, por favor valide la referencia o comuníquese a las líneas para realizar la consulta.",
                  items: ["Bogotá: (601) 7462060 ext. 21423", "Cali: (602) 4850707 ext. 21423", "Medellín: (604) 6044835 ext. 21423", "Barranquilla: (605) 3861198 ext. 21423"],
                  messageFoot: ""
                }
              }];

              this.showError = true;


            }

          } else {

            this.alerts = [{
              type: "danger", message: {
                messageTitle: "Error en la consulta, por favor intente más tarde o comuníquese a las líneas para realizar la consulta.",
                items: ["Bogotá: (601) 7462060 ext. 21423", "Cali: (602) 4850707 ext. 21423", "Medellín: (604) 6044835 ext. 21423", "Barranquilla: (605) 3861198 ext. 21423"],
                messageFoot: ""
              }
            }];

            this.showError = true;

          }

          this.spinner.setShow();

        }, (err) => {

       

          if (err.status == 401) {

            this.alerts = [{
              type: "danger", message: {
                messageTitle: "Error en la consulta, por favor intente más tarde o comuníquese a las líneas para realizar la consulta.",
                items: ["Bogotá: (601) 7462060 ext. 21423", "Cali: (602) 4850707 ext. 21423", "Medellín: (604) 6044835 ext. 21423", "Barranquilla: (605) 3861198 ext. 21423"],
                messageFoot: ""
              }
            }];

            this.showError = true;

          } else if (err.status == 403) {

            this.alerts = [{
              type: "danger", message: {
                messageTitle: "Error en la consulta, se ha superado el número de intentos permitidos por usuario, por favor intente más tarde o comuníquese a las siguientes líneas de atención.",
                items: ["Bogotá: (601) 7462060 ext. 21423", "Cali: (602) 4850707 ext. 21423", "Medellín: (604) 6044835 ext. 21423", "Barranquilla: (605) 3861198 ext. 21423"],
                messageFoot: ""
              }
            }];

            this.showError = true;

          }
          else if (err.status == 0) {

            this.alerts = [{
              type: "danger", message: {
                messageTitle: "Error en la consulta, se ha superado el número de intentos permitidos por usuario, por favor intente más tarde o comuníquese a las siguientes líneas de atención.",
                items: ["Bogotá: (601) 7462060 ext. 21423", "Cali: (602) 4850707 ext. 21423", "Medellín: (604) 6044835 ext. 21423", "Barranquilla: (605) 3861198 ext. 21423"],
                messageFoot: ""
              }
            }];

            this.showError = true;

          }
           else {

            this.alerts = [{
              type: "danger", message: {
                messageTitle: "Error en la consulta, por favor intente más tarde o comuníquese a las líneas para realizar la consulta.",
                items: ["Bogotá: (601) 7462060 ext. 21423", "Cali: (602) 4850707 ext. 21423", "Medellín: (604) 6044835 ext. 21423", "Barranquilla: (605) 3861198 ext. 21423"],
                messageFoot: ""
              }
            }];

            this.showError = true;
          }

          this.spinner.setShow();

        })

      this.loading = !this.loading;
    }
  }

}

